import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Store from './store/store';
import Banner from './store/Banner';
import ThemeProvider from './ThemeContext';
import './fontawesome';
import Articles from './store/Articles';
import News from './store/News';
import Users from './store/Users';
import Pages from './store/Pages';
import Site from './store/Site';
import RoleManagement from './store/RoleManagement';

interface State {
  store: Store,
  banner: Banner,
  articles: Articles,
  news: News,
  users: Users
  pages: Pages
  site: Site
  roles: RoleManagement
}

const storeList = {
  store: new Store(),
  banner: new Banner(),
  articles: new Articles(),
  news: new News(),
  users: new Users(),
  pages: new Pages(),
  site: new Site(),
  roles: new RoleManagement(),
}

export const Context = createContext<State>(storeList)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Context.Provider value={storeList}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </Context.Provider>
);
